import common from './common';
import main from './main';

const zhCn = { common, main };
export default zhCn;
